<template>
  <div class="ccd-advance-search">
    <div
      v-for="list in advanceList"
      :key="list.title"
      :class="['ad-list', list.title]"
    >
      <span class="title">{{ $t(list.title) }}</span>
      <div class="filter-area">
        <SearchFilter
          v-for="item in list.list"
          :key="item.name"
          :label="$t(item.title)"
          :cls="item.name"
          :inputType="item.inputType"
          :type="item.name"
          :secondtype="item.style"
          :value="passvalue(item)"
          :customLabel="item.customLabel"
          :onchange="changeSearchFilter"
          :options="getOptions(item, item.options)"
          :multiple="item.multiple"
          :searchable="item.searchable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchFilter from './SearchFilter'
import searchFilterOptionMixin from './searchFilterOptionMixin'
import { advanceCompanyList, advanceLeaseList, getAdvanceContact } from './Contains'

export default {
  name: 'Search',
  components: {
    SearchFilter,
  },
  mixins: [ searchFilterOptionMixin ],
  props: {
    onchange: {
      type: Function,
      default: () => {},
    },
    searchItems: {
      type: Object,
    },
    Buildings: {
      type: Array,
    },
    BuildingFloorZoneMap: {
      type: Object,
    },
  },
  data () {
    return {
      advanceList: [
        {
          title: 'contact.company',
          list: advanceCompanyList,
        }, {
          title: 'company.titles.tenancyRecord',
          list: advanceLeaseList,
        }, {
          title: 'company.titles.contact',
          list: getAdvanceContact(),
        },
      ],
    }
  },
  methods: {
    changeSearchFilter (val) {
      typeof this.onchange === 'function' && this.onchange(val)
    },
  },
}
</script>

<style lang="scss">
.ccd-advance-search {
  background: #F8F8F8 ;
  padding: 0 23px;
  color: #0C3A58;

  .ad-list {
    border-bottom: 1px solid #E0E1E4;
    display: flex;
    padding: 16px 0;

    .filter-area {
      flex: 1;
      display: inline-block;
    }

    span.title {
      margin-right: 5px;
      width: 200px;
      text-transform: uppercase;
      font-family: Verdana;
      font-weight: bold;
      font-size: 18px;
      color: #0C3A58;
    }
    .search-filter-input {
      height: 68.8px;
      margin-right: 20px;
      div.row {
        line-height: 0;
      }

      /* Text inputs — baseline fd0d90669 natural box width 178px (legacy .ad-list.* section rules never matched) */
      &.id,
      &.name,
      &.tradeName,
      &.premises,
      &.firstName,
      &.lastName,
      &.phone,
      &.fax,
      &.email {
        width: 178px;
      }
      &.createdAt,
      &.updatedAt {
        width: 375px;
        vertical-align: top;
        .vdp-datepicker.columns {
          width: 188px;
          display: inline-block;
          input.date-picker-class {
            line-height: 0;
          }
          .vdp-datepicker__calendar {
            font-size: 14px;
          }
        }
        .vdp-datepicker.columns:last-child {
          margin-left: -1px;
        }
      }

      /* HKLSelect / HKLMultiSelect — mirror legacy .multiselect (154px control, 112px inner input/tags) */
      &.type,
      &.active,
      &.buildingCode,
      &.floor,
      &.zone,
      &.prefix {
        min-width: 154px;
      }
      &.roleType {
        min-width: 180px;
      }
      .select-area ::v-deep .hkl-select:not(.ant-select-disabled) {
        width: 100%;
        min-width: 100px;
        min-height: 40px;
        max-height: none;
        padding-right: 40px;
        box-sizing: border-box;
        background: #fff;
        .ant-select-selection {
          background: none;
        }
        .ant-select-selection--multiple {
          width: calc(100% - 40px);
          max-width: 112px;
        }
        .ant-select-selection--multiple .ant-select-selection__rendered {
          margin-right: 0;
        }
        .ant-select-arrow {
          right: 9px;
        }
      }
      .select-area ::v-deep .hkl-select .ant-select-search {
        width: 112px;
        min-width: 112px;
      }
      .select-area ::v-deep .hkl-select .ant-select-search input {
        background: none;
        width: 112px;
        min-width: 112px;
      }
      &.prefix .select-area ::v-deep .hkl-select .ant-select-search input {
        width: 65px;
      }
      /* Multi-select — full .hkl-select (legacy .multiselect), inner .ant-select-selection (legacy .multiselect__tags) */
      &.buildingCode,
      &.floor,
      &.zone {
        height: auto;
        min-height: 68.8px;
        .select-area ::v-deep .hkl-select:not(.ant-select-disabled) {
          height: auto;
          min-height: 38px;
          width: 100%;
          .ant-select-selection--multiple {
            overflow-y: auto;
            height: auto;
            min-height: 38px;
            width: calc(100% - 40px);
            max-width: 112px;
            background: none;
          }
        }
        .select-area ::v-deep .ant-select-disabled.hkl-select {
          height: auto;
          min-height: 38px;
          width: 100%;
          .ant-select-selection--multiple {
            overflow-y: auto;
            height: auto;
            min-height: 38px;
            width: 100%;
            max-width: none;
          }
        }
      }
    }
  }
}
</style>
